export const favbarButtons = [
  { label: 'Settings', route: '/settings', module_id: 7, module_key: 'settings' },
  { label: 'Reports', route: '/reports', module_id: 8, module_key: 'accounting' },
];

export const sidebarItems = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    icon: 'dashboard',
    route: '/dashboard',
    module_id: 1,
    actions: {
      showFavorite: true,
      showSettings: true,
      showBulkUpload: false,
      buttons: [
        {
          label: 'Create PO',
          route: '/purchase-order/create',
        },
      ],
    },
  },
  {
    key: 'vendor',
    label: 'Vendor',
    icon: 'patients',
    route: '/vendors',
    module_id: 2,
    module_key: 'vendors',
    children: [
      {
        label: 'List',
        route: '/vendors',
        module_id: 2,
        sub_module_id: 1,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: true,
          redirectButtons: [
            {
              label: 'Create Vendor',
              route: '/vendors/onboarding',
            },
          ],
        },
      },
      {
        label: 'Purchase Order',
        route: '/vendors/purchase-order/list',
        module_id: 2,
        sub_module_id: 3,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
          redirectButtons: [
            {
              label: 'Create PO',
              route: '/vendors/purchase-order',
            },
          ],
        },
      },

      {
        label: 'GRN',
        route: '/vendors/grn',
        module_id: 2,
        sub_module_id: 5,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
          redirectButtons: [
            {
              label: 'Create GRN',
              route: '/vendors/grn/create',
            },
          ],
        },
      },
      {
        label: 'Purchase Invoice',
        route: '/vendors/purchase-invoice/list',
        module_id: 2,
        sub_module_id: 4,
        actions: {
          showFavorite: false,
          showSettings: false,
          showBulkUpload: false,
          redirectButtons: [
            {
              label: 'Create Puchase Invoice',
              route: '/vendors/purchase-invoice',
            },
          ],
        },
      },
      {
        label: 'Payment',
        route: '/vendors/vendor-payment-list',
        module_id: 2,
        sub_module_id: 8,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: true,
          redirectButtons: [
            {
              label: 'Create Advance Payment',
              route: '/vendors/advancePayment',
            },
            {
              label: 'Create Payment',
              route: '/vendors/vendor-payment',
            },
          ],
        },
      },
      { label: 'Return', route: '/vendors/return/list' },

      {
        label: 'Debit Note',
        route: '/vendors/debit-note/list',
        module_id: 2,
        sub_module_id: 10,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: true,
          redirectButtons: [
            {
              label: 'Create Debit Note',
              route: '/vendors/debit-note',
            },
          ],
        },
      },
      {
        label: 'Settlement',
        route: '/vendors/settlement',
        module_id: 2,
        sub_module_id: 20,
        actions: {
          showFavorite: false,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      // {
      //   label: 'Vendor Ledger',
      //   route: '/vendor-ledger',
      //   module_id: 2,
      //   sub_module_id: 11,
      //   actions: {
      //     showFavorite: true,
      //     showSettings: true,
      //     showBulkUpload: false
      //   }
      // },
    ],
  },
  {
    key: 'client',
    label: 'Client',
    icon: 'patients',
    route: '/clients',
    module_id: 3,
    module_key: 'clients',
    children: [
      {
        label: 'List',
        route: '/clients',
      },
      {
        label: 'Sales Order',
        route: '/clients/sales-order/list',
        module_id: 2,
        sub_module_id: 3,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
          redirectButtons: [
            {
              label: 'Create SO',
              route: '/clients/sales-order',
            },
          ],
        },
      },
      {
        label: 'Sales Invoice',
        route: '/clients/client-invoice/list',
        module_id: 3,
        sub_module_id: 4,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
          redirectButtons: [
            {
              label: 'Invoice',
              route: '/clients/client-invoice',
            },
          ],
        },
      },
      { label: 'Receipt', route: '/clients/client-payment-list' },
      {
        label: 'Return',
        route: '/clients/return/list',
        module_id: 3,
        sub_module_id: 7,
      },
      {
        label: 'Credit Note',
        route: '/clients/credit-note/list',
        module_id: 3,
        sub_module_id: 8,
      },
      { label: 'Refund', route: '/clients/refund-payment/list' },
      {
        label: 'Settlement',
        route: '/clients/settlement',
        module_id: 3,
        sub_module_id: 21,
        actions: {
          showFavorite: false,
          showSettings: false,
          showBulkUpload: false,
        },
      },
    ],
  },
  // {
  //   key: 'clinical',
  //   label: 'Clinical Operations',
  //   icon: 'clinical',
  //   module_id: 4,
  //   children: [
  //     { label: 'Queue', route: '/clinical/queue', module_id: 4, sub_module_id: 1 },
  //     { label: 'IPD List', route: '/clinical/ipd', module_id: 4, sub_module_id: 2 },
  //     { label: 'Prescriptions', route: '/clinical/prescriptions', module_id: 4, sub_module_id: 3 },
  //     { label: 'Flowboard', route: '/clinical/flowboard', module_id: 4, sub_module_id: 4 },
  //   ],
  // },
  {
    key: 'approvals',
    label: 'Approvals',
    icon: 'approvals',
    route: '/approvals',
    module_id: 5,
    module_key: 'settings',
  },
  // { key: 'appointments', label: 'Appointments', icon: 'appointments', route: '/appointments', module_id: 6 },
  {
    key: 'finance',
    label: 'Finance',
    icon: 'finance',
    route: '/finance',
    module_id: 7,
    module_key: 'accounting',
    children: [
      {
        label: 'Journal Vouchers',
        route: '/finance/journal-vouchers',
        module_id: 7,
        sub_module_id: 1,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
          redirectButtons: [
            {
              label: 'Create Journal Voucher',
              route: '/finance/journal-vouchers/create',
            },
          ],
        },
      },
      {
        label: 'General Ledger',
        route: '/finance/general-ledger',
        module_id: 7,
        sub_module_id: 4,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
        },
      },
      {
        label: 'Trial Balance',
        route: '/finance/trial-balance',
        module_id: 7,
        sub_module_id: 5,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
        },
      },
      {
        label: 'Balance Sheet',
        route: '/finance/balance-sheet',
        module_id: 7,
        sub_module_id: 16,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'Chart of Accounts',
        route: '/finance/chart-of-accounts',
        module_id: 7,
        sub_module_id: 6,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
        },
      },
      {
        label: 'AP Register',
        route: '/finance/ap-register',
        module_id: 7,
        sub_module_id: 11,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'GL Search',
        route: '/finance/gl-search',
        module_id: 7,
        sub_module_id: 18,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'AR Register',
        route: '/finance/ar-register',
        module_id: 7,
        sub_module_id: 12,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'Vendor Ledger',
        route: '/vendor-ledger',
        module_id: 7,
        sub_module_id: 14,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'Client Ledger',
        route: '/client-ledger',
        module_id: 7,
        sub_module_id: 15,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
    ],
  },
  {
    key: 'inventory',
    label: 'Inventory',
    icon: 'items',
    route: '/inventory',
    module_id: 8,
    module_key: 'inventory',
    children: [
      {
        label: 'Stock List',
        route: '/inventory',
        module_id: 8,
        sub_module_id: 1,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: true,
        },
      },
      {
        label: 'Adjustment',
        route: '/inventory-adjustment/list',
        module_id: 8,
        sub_module_id: 2,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
          redirectButtons: [
            {
              label: 'Create Adjustment',
              route: '/inventory-adjustment',
            },
          ],
        },
      },
    ],
  },
  {
    key: 'items',
    label: 'Items',
    icon: 'items',
    route: '/items/list',
    module_id: 11,
    module_key: 'items',
  },
  {
    key: 'assets',
    label: 'Asset',
    icon: 'items',
    route: '/assets',
    module_id: 12,
    module_key: 'asset',
    children: [
      {
        label: 'My Assets',
        route: '/assets/my-assets',
        module_id: 12,
        sub_module_id: 0,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
        },
      },
      {
        label: 'Asset List',
        route: '/assets',
        module_id: 12,
        sub_module_id: 1,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
          redirectButtons: [
            {
              label: 'Add Asset',
              route: '/assets/add',
            },
          ],
        },
      },
      {
        label: 'Asset Request',
        route: '/assets/asset-request/list',
        module_id: 12,
        sub_module_id: 2,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
          redirectButtons: [
            {
              label: 'Create Asset Request',
              route: '/assets/asset-request/create',
            },
          ],
        },
      },
      {
        label: 'Maintenance Request',
        route: '/assets/asset-maintenance-requests/list',
        module_id: 12,
        sub_module_id: 3,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
          redirectButtons: [
            {
              label: 'Create Maintenance Request',
              route: '/assets/asset-maintenance-requests/create',
            },
          ],
        },
      },
      {
        label: 'My Maintenance Requests',
        route: '/assets/my-maintenance-requests',
        module_id: 12,
        sub_module_id: 3,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
          redirectButtons: [
            {
              label: 'Create Maintenance Request',
              route: '/assets/asset-maintenance-requests/create',
            },
          ],
        },
      },
      {
        label: 'Transfer Asset',
        route: '/assets/transfers/list',
        module_id: 12,
        sub_module_id: 4,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
          redirectButtons: [
            {
              label: 'Create Transfer Asset',
              route: '/assets/transfers/create',
            },
          ],
        },
      },
      {
        label: 'Remove Asset',
        route: '/assets/removals/list',
        module_id: 12,
        sub_module_id: 6,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
          redirectButtons: [
            {
              label: 'Create Removal',
              route: '/assets/removals/create',
            },
          ],
        },
      },
      {
        label: 'Write Off',
        route: '/assets/write-offs/list',
        module_id: 12,
        sub_module_id: 5,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
          redirectButtons: [
            {
              label: 'Create Write-Off',
              route: '/assets/write-offs/create',
            },
          ],
        },
      },
    ],
  },

  {
    key: 'reports',
    label: 'Reports',
    icon: 'reports',
    route: '/reports',
    module_id: 9,
    module_key: 'accounting',
    children: [
      {
        label: 'Transaction Details',
        route: '/finance/transaction-details',
        module_id: 7,
        sub_module_id: 2,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
        },
      },
      {
        label: 'AP Aging Summary',
        route: '/finance/ap-aging-summary',
        module_id: 7,
        sub_module_id: 7,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'AP Aging Details',
        route: '/finance/ap-aging-details',
        module_id: 7,
        sub_module_id: 8,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'Income Statement',
        route: '/finance/income-statement',
        module_id: 7,
        sub_module_id: 3,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
        },
      },
      {
        label: 'Income Statement Summary',
        route: '/finance/income-statement-summary',
        module_id: 7,
        sub_module_id: 13,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'AR Aging Summary',
        route: '/finance/ar-aging-summary',
        module_id: 7,
        sub_module_id: 9,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'AR Aging Details',
        route: '/finance/ar-aging-details',
        module_id: 7,
        sub_module_id: 10,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'Expense Wise Report',
        route: '/reports/expense-report',
        module_id: 9,
        sub_module_id: 11,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'TDS Report',
        route: '/reports/tds-report',
        module_id: 9,
        sub_module_id: 12,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'Sale Report',
        route: '/reports/sale-report',
        module_id: 9,
        sub_module_id: 14,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'Finance Sale Report',
        route: '/reports/finance-sale-report',
        module_id: 9,
        sub_module_id: 14,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'Sales Return Report',
        route: '/reports/sales-return-report',
        module_id: 9,
        sub_module_id: 15,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'Journal Voucher Report',
        route: '/reports/journal-voucher-report',
        module_id: 9,
        sub_module_id: 16,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'Purchase Report',
        route: '/finance/purchase-report',
        module_id: 7,
        sub_module_id: 13,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'Sales Order Report',
        route: '/finance/sales-order-report',
        module_id: 7,
        sub_module_id: 0,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'A/P Payment History',
        route: '/finance/ap-payment-history',
        module_id: 7,
        sub_module_id: 17,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
      {
        label: 'Open Purchase Invoices',
        route: '/finance/open-purchase-invoices',
        module_id: 7,
        sub_module_id: 14,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
        },
      },
    ],
  },
  {
    key: 'settings',
    label: 'Settings',
    icon: 'settings',
    route: '/settings',
    module_id: 10,
    module_key: 'settings',
    children: [
      {
        label: 'Masters',
        route: '/settings/masters',
        module_id: 10,
        sub_module_id: 1,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
          redirectButtons: [
            // Add master action buttons here
          ],
        },
        children: [
          {
            label: 'Terms',
            route: '/settings/masters/terms',
            module_id: 10,
            sub_module_id: 1,
          },
          {
            label: 'Vendor Type',
            route: '/settings/masters/vendor-type',
            module_id: 10,
            sub_module_id: 2,
          },
          {
            label: 'Vendor Group',
            route: '/settings/masters/vendor-group',
            module_id: 10,
            sub_module_id: 3,
          },
          {
            label: 'Vendor Category',
            route: '/settings/masters/category',
            module_id: 10,
            sub_module_id: 4,
          },
          {
            label: 'Nature Of Document',
            route: '/settings/masters/nature-of-document',
            module_id: 10,
            sub_module_id: 5,
          },
          {
            label: 'TDS Section',
            route: '/settings/masters/tds-section',
            module_id: 10,
            sub_module_id: 6,
          },
          {
            label: 'TCS Section',
            route: '/settings/masters/tcs-section',
            module_id: 10,
            sub_module_id: 33,
          },
          {
            label: 'Reason For Return',
            route: '/settings/masters/reason-for-return',
            module_id: 10,
            sub_module_id: 7,
          },
          {
            label: 'Reason For Credit Note',
            route: '/settings/masters/reason-for-credit-note',
            module_id: 10,
            sub_module_id: 8,
          },
          {
            label: 'Shipping Method',
            route: '/settings/masters/shipping-method',
            module_id: 10,
            sub_module_id: 9,
          },
          {
            label: 'Refund Method',
            route: '/settings/masters/refund-method',
            module_id: 10,
            sub_module_id: 10,
          },
          {
            label: 'Bank Name',
            route: '/settings/masters/bank-name',
            module_id: 10,
            sub_module_id: 11,
          },
          {
            label: 'Bank Details',
            route: '/settings/masters/bank-details',
            module_id: 10,
            sub_module_id: 12,
          },
          {
            label: 'Client Category',
            route: '/settings/masters/client-category',
            module_id: 10,
            sub_module_id: 12,
          },
          {
            label: 'Client Group',
            route: '/settings/masters/client-group',
            module_id: 10,
            sub_module_id: 13,
          },
          {
            label: 'Contact Role',
            route: '/settings/masters/contact-role',
            module_id: 10,
            sub_module_id: 14,
          },
          {
            label: 'Line of Business',
            route: '/settings/masters/line-of-business',
            module_id: 10,
            sub_module_id: 15,
          },
          {
            label: 'Sales Type',
            route: '/settings/masters/sales-type',
            module_id: 10,
            sub_module_id: 16,
          },
          {
            label: 'Shipping Carrier',
            route: '/settings/masters/shipping-carrier',
            module_id: 10,
            sub_module_id: 17,
          },
          {
            label: 'Chart of Accounts',
            route: '/settings/masters/chart-of-accounts',
            module_id: 10,
            sub_module_id: 18,
          },
          {
            label: 'Manufacturer',
            route: '/settings/masters/manufacturer',
            module_id: 10,
            sub_module_id: 19,
          },
          {
            label: 'Item Unit',
            route: '/settings/masters/item-unit',
            module_id: 10,
            sub_module_id: 20,
          },
          {
            label: 'Item Type',
            route: '/settings/masters/item-type',
            module_id: 10,
            sub_module_id: 21,
          },
          {
            label: 'Nature of Goods',
            route: '/settings/masters/nature-of-goods',
            module_id: 10,
            sub_module_id: 22,
          },
          {
            label: 'Cost Category',
            route: '/settings/masters/cost-category',
            module_id: 10,
            sub_module_id: 23,
          },
          {
            label: 'Expiry Category',
            route: '/settings/masters/expiry-category',
            module_id: 10,
            sub_module_id: 24,
          },
          {
            label: 'Storage Option',
            route: '/settings/masters/storage-option',
            module_id: 10,
            sub_module_id: 25,
          },
          {
            label: 'File Type',
            route: '/settings/masters/file-type',
            module_id: 10,
            sub_module_id: 26,
          },
          {
            label: 'Fiscal Period',
            route: '/settings/masters/fiscal-period',
            module_id: 10,
            sub_module_id: 27,
          },
          {
            label: 'Asset Group',
            route: '/settings/masters/asset-group',
            module_id: 10,
            sub_module_id: 28,
          },
          {
            label: 'Asset Sub Group',
            route: '/settings/masters/asset-sub-group',
            module_id: 10,
            sub_module_id: 29,
          },
          {
            label: 'Maintenance Type',
            route: '/settings/masters/maintenance-type',
            module_id: 10,
            sub_module_id: 30,
          },
          {
            label: 'Department',
            route: '/settings/masters/department',
            module_id: 10,
            sub_module_id: 31,
          },
          {
            label: 'Sub Location',
            route: '/settings/masters/sub-location',
            module_id: 10,
            sub_module_id: 32,
          },
          {
            label: 'Asset Write Off Reason',
            route: '/settings/masters/asset-write-off-reason',
            module_id: 10,
            sub_module_id: 33,
          },
          {
            label: 'Asset Maintenance Issue Type',
            route: '/settings/masters/asset-maintenance-issue-type',
            module_id: 10,
            sub_module_id: 34,
          },
          {
            label: 'Asset Maintenance Warranty Type',
            route: '/settings/masters/asset-maintenance-warranty-type',
            module_id: 10,
            sub_module_id: 35,
          },
        ],
      },
      {
        label: 'Form Builder',
        route: '/settings/dashboard',
        module_id: 10,
        sub_module_id: 12,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
          redirectButtons: [],
        },
      },
      {
        label: 'Approval Workflows',
        route: '/settings/approval-workflows',
        module_id: 10,
        sub_module_id: 11,
        actions: {
          showBack: false,
          showFavorite: false,
          showSettings: false,
          showBulkUpload: false,
          redirectButtons: [
            {
              label: 'Create Workflow',
              route: '/settings/approval-workflows/create',
            },
          ],
        },
      },
      {
        label: 'Account Settings',
        route: '/settings/account_settings',
        module_id: 10,
        sub_module_id: 13,
        actions: {
          showFavorite: true,
          showSettings: true,
          showBulkUpload: false,
          redirectButtons: [
            // Add account settings action buttons here
          ],
        },
        children: [
          {
            label: 'Users',
            route: '/settings/account_settings/users',
            module_id: 10,
            sub_module_id: 13,
            actions: {
              showFavorite: true,
              showSettings: true,
              showBulkUpload: false,
              redirectButtons: [
                {
                  label: 'Create User',
                  route: '/settings/account_settings/users/create',
                },
              ],
            },
          },
          {
            label: 'Roles',
            route: '/settings/account_settings/roles',
            module_id: 10,
            sub_module_id: 13,
            actions: {
              showFavorite: true,
              showSettings: true,
              showBulkUpload: false,
              redirectButtons: [],
            },
          },
          {
            label: 'User Roles',
            route: '/settings/account_settings/user-roles',
            module_id: 10,
            sub_module_id: 13,
            actions: {
              showFavorite: true,
              showSettings: true,
              showBulkUpload: false,
              redirectButtons: [],
            },
          },
        ],
      },
      {
        label: 'Sequence Configuration',
        route: '/settings/sequence-config',
        module_id: 10,
        sub_module_id: 14,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
          redirectButtons: [],
        },
      },
      {
        label: 'PDF Settings',
        route: '/settings/pdf-settings',
        module_id: 10,
        sub_module_id: 15,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
          redirectButtons: [],
        },
      },
      {
        label: 'Accounting Dimensions',
        route: '/settings/accounting-dimensions',
        module_id: 10,
        sub_module_id: 16,
        actions: {
          showFavorite: true,
          showSettings: false,
          showBulkUpload: false,
          redirectButtons: [],
        },
      },
    ],
  },
];

export const searchModuleOptions = [
  { label: 'Vendor', prefix: 'Vendor:', icon: 'pi-truck', color: '#8B5CF6' },
  { label: 'Client', prefix: 'Client:', icon: 'pi-users', color: '#3B82F6' },
  { label: 'Invoice', prefix: 'Invoice:', icon: 'pi-file', color: '#10B981' },
  { label: 'Order', prefix: 'Order:', icon: 'pi-shopping-cart', color: '#F59E0B' },
  { label: 'Item', prefix: 'Item:', icon: 'pi-box', color: '#EC4899' },
  { label: 'GRN', prefix: 'GRN:', icon: 'pi-inbox', color: '#6366F1' },
  { label: 'Return', prefix: 'Return:', icon: 'pi-replay', color: '#EF4444' },
  { label: 'Payment', prefix: 'Payment:', icon: 'pi-wallet', color: '#14B8A6' },
  { label: 'Journal', prefix: 'Journal:', icon: 'pi-book', color: '#6366F1' },
  { label: 'Inventory', prefix: 'Inventory:', icon: 'pi-sliders-h', color: '#8B5CF6' },
  { label: 'Refund', prefix: 'Refund:', icon: 'pi-money-bill', color: '#F97316' },
];
